// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@property --shimmer-transparency {
  syntax: '<percentage>';
  /* <- defined as type number for the transition to work */
  initial-value: 20%;
  inherits: false;
}
.ULwfAYtsRbuX6D {
  width: 100%;
  height: 56px;
  margin-bottom: 12px;
  cursor: progress;
  background-color: color-mix(in srgb, var(--board-header-background-color, var(--ds-surface-hovered, #f1f2f4)) var(--shimmer-transparency, 100%), transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation-name: ezTc25Ew6oP6AC;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes ezTc25Ew6oP6AC {
  from {
    --shimmer-transparency: 100%;
  }
  to {
    --shimmer-transparency: 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .ULwfAYtsRbuX6D {
    animation: none;
    --shimmer-transparency: 100%;
  }
}
.qnXqEdOlQwGcNq {
  display: flex;
  flex-direction: row;
  padding: 0 6px;
  list-style: none;
}
.GufEKeXXKVJ9bq {
  flex-shrink: 0;
  width: 272px;
  margin: 0 6px;
  border-radius: 12px;
  vertical-align: top;
  cursor: progress;
  background-color: color-mix(in srgb, var(--board-header-background-color, var(--ds-surface-hovered, #f1f2f4)) var(--shimmer-transparency, 100%), transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation-name: ezTc25Ew6oP6AC;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes ezTc25Ew6oP6AC {
  from {
    --shimmer-transparency: 100%;
  }
  to {
    --shimmer-transparency: 50%;
  }
}
.GufEKeXXKVJ9bq:nth-of-type(1) {
  background-color: color-mix(in srgb, var(--board-header-background-color, var(--ds-surface-hovered, #f1f2f4)) var(--shimmer-transparency, 100%), transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation: yrmTlodfIkvyjk 7.2s infinite normal, ezTc25Ew6oP6AC 1.5s linear infinite alternate;
}
@keyframes yrmTlodfIkvyjk {
  0% {
    animation-timing-function: linear;
    height: 306px;
  }
  6.94% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 306px;
  }
  33.33% {
    animation-timing-function: linear;
    height: 44px;
  }
  40.28% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 44px;
  }
  66.67% {
    animation-timing-function: linear;
    height: 162px;
  }
  73.61% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 162px;
  }
  100% {
    animation-timing-function: linear;
    height: 306px;
  }
}
@keyframes ezTc25Ew6oP6AC {
  from {
    --shimmer-transparency: 100%;
  }
  to {
    --shimmer-transparency: 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .GufEKeXXKVJ9bq:nth-of-type(1) {
    animation: none;
    --shimmer-transparency: 100%;
  }
}
.GufEKeXXKVJ9bq:nth-of-type(2) {
  background-color: color-mix(in srgb, var(--board-header-background-color, var(--ds-surface-hovered, #f1f2f4)) var(--shimmer-transparency, 100%), transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation: kOT0FzedrRMoxM 7.2s infinite normal, ezTc25Ew6oP6AC 1.5s linear infinite alternate;
}
@keyframes kOT0FzedrRMoxM {
  0% {
    animation-timing-function: linear;
    height: 162px;
  }
  6.94% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 162px;
  }
  33.33% {
    animation-timing-function: linear;
    height: 306px;
  }
  40.28% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 306px;
  }
  66.67% {
    animation-timing-function: linear;
    height: 44px;
  }
  73.61% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 44px;
  }
  100% {
    animation-timing-function: linear;
    height: 162px;
  }
}
@keyframes ezTc25Ew6oP6AC {
  from {
    --shimmer-transparency: 100%;
  }
  to {
    --shimmer-transparency: 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .GufEKeXXKVJ9bq:nth-of-type(2) {
    animation: none;
    --shimmer-transparency: 100%;
  }
}
.GufEKeXXKVJ9bq:nth-of-type(3) {
  background-color: color-mix(in srgb, var(--board-header-background-color, var(--ds-surface-hovered, #f1f2f4)) var(--shimmer-transparency, 100%), transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation: LT41Bd0mG2MRqa 7.2s infinite normal, ezTc25Ew6oP6AC 1.5s linear infinite alternate;
}
@keyframes LT41Bd0mG2MRqa {
  0% {
    animation-timing-function: linear;
    height: 44px;
  }
  6.94% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 44px;
  }
  33.33% {
    animation-timing-function: linear;
    height: 162px;
  }
  40.28% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 162px;
  }
  66.67% {
    animation-timing-function: linear;
    height: 306px;
  }
  73.61% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 306px;
  }
  100% {
    animation-timing-function: linear;
    height: 44px;
  }
}
@keyframes ezTc25Ew6oP6AC {
  from {
    --shimmer-transparency: 100%;
  }
  to {
    --shimmer-transparency: 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .GufEKeXXKVJ9bq:nth-of-type(3) {
    animation: none;
    --shimmer-transparency: 100%;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardHeaderSkeleton": `ULwfAYtsRbuX6D`,
	"shimmer": `ezTc25Ew6oP6AC`,
	"lists": `qnXqEdOlQwGcNq`,
	"listSkeleton": `GufEKeXXKVJ9bq`,
	"listSkeletonAnimation1": `yrmTlodfIkvyjk`,
	"listSkeletonAnimation2": `kOT0FzedrRMoxM`,
	"listSkeletonAnimation3": `LT41Bd0mG2MRqa`
};
export default ___CSS_LOADER_EXPORT___;
